var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF754C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6333 17.6045C29.145 18.0928 28.3521 18.0928 27.8638 17.6045C23.52 13.2607 16.4771 13.2607 12.1333 17.6045C11.645 18.0889 10.8521 18.0889 10.3638 17.5967C9.8833 17.1084 9.8833 16.3232 10.3677 15.835C15.6802 10.5147 24.3013 10.5068 29.6216 15.8193C29.6255 15.8232 29.6294 15.8272 29.6372 15.835C30.1177 16.3232 30.1138 17.1123 29.6333 17.6045ZM14.2349 19.7061C13.7466 20.1943 13.7466 20.9873 14.2349 21.4756C14.7231 21.9639 15.5161 21.9639 16.0044 21.4756C18.2075 19.2725 21.7935 19.2725 24.0005 21.4756C24.4888 21.9639 25.2817 21.9639 25.77 21.4756C26.2583 20.9873 26.2583 20.1943 25.77 19.7061C22.5864 16.5264 17.4146 16.5264 14.2349 19.7061ZM21.895 23.5732C22.9419 24.6201 22.9419 26.3193 21.895 27.3662C20.8481 28.4131 19.1489 28.4131 18.1021 27.3662C17.0552 26.3193 17.0552 24.6201 18.1021 23.5732C19.1372 22.5264 20.8208 22.5147 21.8677 23.5498C21.8794 23.5576 21.8872 23.5654 21.895 23.5732Z",
    fill: "#FF754C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.67847abeb097984b5ea51a4204f43a87.svg";
export { ForwardRef as ReactComponent };